import {
  CHANGE_INPUT,
  CHANGE_STEP,
  CHANGE_VALIDATION_FAILURE,
  FLEX_DRAFT_CHANGE,
  FLEX_DRAFT_CHANGE_FAILURE,
  FLEX_DRAFT_CHANGE_SUCCESS,
  FLEX_DRAFT_FETCH_STATUS,
  FLEX_DRAFT_FETCH_STATUS_FAILURE,
  FLEX_DRAFT_FETCH_STATUS_SUCCESS,
  RESET_CONFIRMATION,
  RESET_FLEX_DRAFT_STATE,
  RESET_FORM_STATE,
  RESET_REQUEST_STATUS,
  SET_IS_AMOUNT_DRAWER_OPEN,
  SET_IS_IN_FLEX_DRAFT_FLOW,
  SET_IS_MODAL_OPEN,
  SET_IS_SCHEDULE_DRAWER_OPEN,
  SET_IS_SECOND_ACCOUNT_FORM_ENABLED,
  SET_SELECTED_DRAFT_SCHEDULE_STEP,
  UPDATE_AMOUNT,
  UPDATE_FORM_ERROR,
} from './constants';

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function changeStep(step) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function changeValidationFailure({ amount }) {
  return {
    payload: { amount },
    type: CHANGE_VALIDATION_FAILURE,
  };
}

export function flexDraftChange({ body, loanNumber }) {
  return {
    payload: { body, loanNumber },
    type: FLEX_DRAFT_CHANGE,
  };
}

export function flexDraftChangeFailure() {
  return { type: FLEX_DRAFT_CHANGE_FAILURE };
}

export function flexDraftChangeSuccess({ confirmationNumber }) {
  return {
    payload: { confirmationNumber },
    type: FLEX_DRAFT_CHANGE_SUCCESS,
  };
}

export function flexDraftFetchStatus() {
  return { type: FLEX_DRAFT_FETCH_STATUS };
}

export function flexDraftFetchStatusFailure({ error }) {
  return {
    payload: { error },
    type: FLEX_DRAFT_FETCH_STATUS_FAILURE,
  };
}

export function flexDraftFetchStatusSuccess({
  allowedOperation,
  allowedSetting,
  pendingSetting,
  statement,
  status,
}) {
  return {
    payload: {
      allowedOperation,
      allowedSetting,
      pendingSetting,
      statement,
      status,
    },
    type: FLEX_DRAFT_FETCH_STATUS_SUCCESS,
  };
}

export function resetConfirmation() {
  return { type: RESET_CONFIRMATION };
}

export function resetFlexDraftState() {
  return { type: RESET_FLEX_DRAFT_STATE };
}

export function resetFormState({ form }) {
  return {
    payload: { form },
    type: RESET_FORM_STATE,
  };
}

export function resetRequestStatus({ statusType }) {
  return {
    payload: { statusType },
    type: RESET_REQUEST_STATUS,
  };
}

export function setIsAmountDrawerOpen(value) {
  return {
    payload: { value },
    type: SET_IS_AMOUNT_DRAWER_OPEN,
  };
}

export function setIsInFlexDraftFlow({ value }) {
  return {
    payload: { value },
    type: SET_IS_IN_FLEX_DRAFT_FLOW,
  };
}

export function setIsModalOpen({ key, value }) {
  return {
    payload: { key, value },
    type: SET_IS_MODAL_OPEN,
  };
}

export function setIsScheduleDrawerOpen(value) {
  return {
    payload: { value },
    type: SET_IS_SCHEDULE_DRAWER_OPEN,
  };
}

export function setIsSecondAccountFormEnabled(value) {
  return {
    payload: { value },
    type: SET_IS_SECOND_ACCOUNT_FORM_ENABLED,
  };
}

export function setSelectedDraftScheduleStep({ step }) {
  return {
    payload: { step },
    type: SET_SELECTED_DRAFT_SCHEDULE_STEP,
  };
}

export function updateAmount({ amount }) {
  return {
    payload: { amount },
    type: UPDATE_AMOUNT,
  };
}

export function updateFormError({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: UPDATE_FORM_ERROR,
  };
}
